// Give taps the same brief reflection as a hover without changing navigation.
const glint = (event) => {
  if (event.type === 'keydown' && event.key !== 'Enter' && event.key !== ' ') return;
  const link = event.target.closest?.('header-drawer .menu-drawer__menu-item--mainlist');
  if (!link) return;
  link.classList.add('argyre-menu-glint');
  window.setTimeout(() => link.classList.remove('argyre-menu-glint'), 1100);
};
document.addEventListener('pointerdown', glint);
document.addEventListener('keydown', glint);
